import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.js-advantages-slider .swiper', {
	slidesPerView: 'auto',
	resistanceRatio: 0,
	navigation: {
		prevEl: '.js-advantages-slider__arrow-prev',
		nextEl: '.js-advantages-slider__arrow-next',
	},
	pagination: {
		el: '.js-advantages-slider__pagination',
	},
	modules: [Navigation, Pagination],
});
